export const RULES = {
  CODE_VERIFICATION: /\b\d{5}\b/,
};
